var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustParticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 80,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 50,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 120,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 200,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 300,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 400,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 450,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 320,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 220,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 370,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 230,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 310,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 90,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 400,
    r: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustParticle);
export default __webpack_public_path__ + "static/media/dustParticle.2f0626c7ab1617e4b928eda066d8871e.svg";
export { ForwardRef as ReactComponent };